(function(){
  function init(){
    var root=document.querySelector('[data-coll-root]');if(!root)return;
    var cards=[].slice.call(root.querySelectorAll('.grid-product'));
    var lockRaw=root.getAttribute('data-lock-colors')||'';
    var lock=lockRaw.split(',').map(function(s){return s.trim()}).filter(Boolean);
    var state={color:[],size:[]};
    var u=new URL(window.location.href);
    ['color','size'].forEach(function(k){
      var raw=u.searchParams.get('f.'+k);
      if(raw)state[k]=raw.split(',').filter(Boolean);
    });
    function has(k,v){return state[k].indexOf(v)>-1}
    function toggle(k,v){var i=state[k].indexOf(v);if(i>-1)state[k].splice(i,1);else state[k].push(v)}
    function push(){
      var u2=new URL(window.location.href);
      ['color','size'].forEach(function(k){
        if(state[k].length)u2.searchParams.set('f.'+k,state[k].join(','));
        else u2.searchParams.delete('f.'+k);
      });
      history.replaceState(null,'',u2.toString());
    }
    function lookup(card,attr,wanted){
      var map=card.getAttribute(attr)||'';
      if(!map||!wanted.length)return null;
      var parts=map.split('~~');
      for(var i=0;i<wanted.length;i++){
        for(var j=0;j<parts.length;j++){
          var kv=parts[j].split('||');
          if(kv[0]===wanted[i]&&kv[1])return kv[1];
        }
      }
      return null;
    }
    function wanted(){ return lock.length?lock:state.color }
    function paint(card){
      var main=card.querySelector('.grid-product__image:not(.grid-product__image--hover)');
      if(!main)return;
      if(main.getAttribute('data-orig')===null)main.setAttribute('data-orig',main.getAttribute('src')||'');
      if(main.getAttribute('data-origset')===null)main.setAttribute('data-origset',main.getAttribute('srcset')||'');
      var w=card.hidden?[]:wanted();
      var pick=w.length?lookup(card,'data-vimg',w):null;
      var hov=card.querySelector('.grid-product__image--hover');
      if(pick){
        if(main.getAttribute('src')!==pick){main.setAttribute('src',pick);main.removeAttribute('srcset');main.removeAttribute('sizes')}
        if(hov)hov.style.display='none';
      }else{
        var o=main.getAttribute('data-orig');
        if(o&&main.getAttribute('src')!==o){
          main.setAttribute('src',o);
          var os=main.getAttribute('data-origset');
          if(os)main.setAttribute('srcset',os);
        }
        if(hov)hov.style.display='';
      }
      var href=w.length?lookup(card,'data-vurl',w):null;
      [].slice.call(card.querySelectorAll('[data-card-link]')).forEach(function(a){
        if(a.getAttribute('data-href-orig')===null)a.setAttribute('data-href-orig',a.getAttribute('href')||'');
        a.setAttribute('href',href||a.getAttribute('data-href-orig'));
      });
      var qv=card.querySelector('[data-quick-view]');
      if(qv){
        if(qv.getAttribute('data-qv-orig')===null)qv.setAttribute('data-qv-orig',qv.getAttribute('data-quick-view')||'');
        qv.setAttribute('data-quick-view',href||qv.getAttribute('data-qv-orig'));
      }
    }
    function sync(){
      [].slice.call(root.querySelectorAll('[data-filter]')).forEach(function(el){
        var on=has(el.getAttribute('data-filter'),el.getAttribute('data-value'));
        el.classList.toggle('is-active',on);el.setAttribute('aria-pressed',on?'true':'false');
      });
      var chips=root.querySelector('[data-chips]');
      if(chips){
        chips.innerHTML='';
        ['color','size'].forEach(function(k){
          state[k].forEach(function(v){
            var b=document.createElement('button');b.type='button';b.className='f-chip';
            b.innerHTML=v+'<span aria-hidden="true">&times;</span>';
            b.setAttribute('aria-label','Remove filter '+v);
            b.addEventListener('click',function(){toggle(k,v);push();sync();apply();});
            chips.appendChild(b);
          });
        });
      }
      var any=state.color.length||state.size.length;
      [].slice.call(root.querySelectorAll('[data-clear]')).forEach(function(el){el.hidden=!any});
    }
    function label(n,suffix){ return n + (n===1?' product':' products') + (suffix||''); }
    function apply(){
      var n=0;
      cards.forEach(function(c){
        var cs=c.getAttribute('data-colors')||'',ss=c.getAttribute('data-sizes')||'';
        var okC=!state.color.length||state.color.some(function(v){return cs.indexOf('~'+v+'~')>-1});
        var okS=!state.size.length||state.size.some(function(v){return ss.indexOf('~'+v+'~')>-1});
        var ok=okC&&okS;c.hidden=!ok;if(ok)n++;
        paint(c);
      });
      var cnt=root.querySelector('[data-pcount]');
      if(cnt){
        /* Unfiltered, say how big the collection really is, not how many fit on
           this page. The filters below are client side, so once one is on the
           number can only describe the current page and says so. */
        var total=parseInt(cnt.getAttribute('data-total'),10);
        var filtered=state.color.length||state.size.length;
        var paged=cnt.getAttribute('data-paged')==='1';
        if(!filtered&&!isNaN(total)){ cnt.textContent=label(total); }
        else { cnt.textContent=label(n, paged?' on this page':''); }
      }
      var empty=root.querySelector('[data-empty]');if(empty)empty.hidden=n>0;
    }
    root.addEventListener('click',function(e){
      if(!e.target.closest)return;
      var f=e.target.closest('[data-filter]');
      if(f){toggle(f.getAttribute('data-filter'),f.getAttribute('data-value'));push();sync();apply();return;}
      if(e.target.closest('[data-clear]')){state.color=[];state.size=[];push();sync();apply();return;}
      if(e.target.closest('[data-f-toggle]')){root.classList.toggle('filters-open');}
    });
    sync();apply();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();
